<template>
  <header class="marketing-email-header-edit">
    <v-stepper class="marketing-email-header-edit-steps"
               :value="step"
               alt-labels
               @input="emitInput">
      <v-stepper-header>

        <v-stepper-step :step="1"
                        :edit-icon="$vuetify.icons.complete"
                        complete
                        editable
                        @click="goToFirstStep">
          {{$t('message.marketingGenerics.message.content')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step v-if="!isAutomationFlow"
                        :step="2"
                        :edit-icon="$vuetify.icons.complete"
                        editable
                        complete
                        @click="goToSecondStep">
            {{$t('message.marketingGenerics.message.recipients')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :step="isAutomationFlow ? 2 : 3"
                        :edit-icon="$vuetify.icons.complete"
                        complete
                        editable
                        @click="goToVerifyStep">
            {{$t('message.marketingGenerics.message.verification')}}
        </v-stepper-step>

        <v-divider v-if="!isAutomationFlow"></v-divider>

        <v-stepper-step v-if="!isAutomationFlow"
                        :step="4"
                        :complete="step > 5"
                        :editable="step > 3">
            {{$t('message.marketingGenerics.message.send')}}
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <div v-if="isContentStep"
         class="marketing-email-header-edit-content">

      <div class="marketing-email-header-edit-content-saving">
        <i class="mdi mdi-content-save-outline"
           :class="{ 'cursor-wait': isContentSaving }"></i>

        <p class="text-bold marketing-email-header-edit-content-saving-text">
          {{ isContentSaving ?  this.$t('message.marketingGenerics.message.saving') : this.$t('message.marketingGenerics.message.saved') }}
        </p>
      </div>

      <button v-if="isStripoEditor || isHtmlEditor"
              class="btn btn-primary btn-extra-round"
              @click="emitNextStep">
          {{$t('message.generics.message.advance')}}
      </button>
    </div>

  </header>
</template>

<script>
import EventBus from "@packages/event-bus/index";

export default {
  props: {},

  components: {},  

  computed: {
    step() {
      return this.$store.state.marketing.email.edit.step;
    },
    isContentSaving() {
      return this.$store.state.marketing.email.isContentSaving;
    },
    isAutomationFlow() {
      return this.$store.state.marketing.email.edit.isAutomationFlow;
    },
    emailId() {
      return this.$store.state.marketing.email.edit.emailId ?
      this.$store.state.marketing.email.edit.emailId :
      this.itemInSessionStorage.id
    },
    isStripoEditor() {
      return this.$store.state.marketing.email.edit.editorType === "STRIPO";
    },
    isHtmlEditor() {
      return this.$store.state.marketing.email.edit.editorType === "HTML";
    },
    isContentStep() {
      return this.step === 1;
    },
    itemInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_item"));     
    },
  },

  data() {
    return {};
  },

  methods: {
    emitInput(newStepVal) {
      this.$store.commit("SET_EMAIL_EDIT_STEP", newStepVal);
    },
    emitNextStep() {
      EventBus.$emit("EMAIL_EDIT_NEXT_STEP");
    },
    goToFirstStep() {
      this.$router.push({
        path: `/marketing/email/editar/${this.emailId}/conteudo`,
      });
    },
    goToSecondStep() {
      this.$router.push({
        path: `/marketing/email/editar/${this.emailId}/destinatarios`,
      });
    },
    goToVerifyStep() {
      this.$router.push({
        path: `/marketing/email/editar/${this.emailId}/verificacao`,
      });
    },
  },

  beforeDestroy() {
    this.$store.commit("SET_EMAIL_EDIT_IS_VIEW", false);
    this.$store.commit("SET_EMAIL_EDIT_STEP", 1);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-email-header-edit {
  display: flex;
  align-items: center;

  .marketing-email-header-edit-steps {
    flex: 1;
    box-shadow: none;

    .v-stepper__header {
      padding: 0 30px;
    }
  }

  .marketing-email-header-edit-content {
    display: flex;
    align-items: center;

    .marketing-email-header-edit-content-saving {
      display: flex;
      align-items: center;
      color: $grey-4;
      min-width: 135px;
      margin-right: 10px;

      .marketing-email-header-edit-content-saving-text {
        margin: 0;
      }

      .mdi {
        font-size: 26px;
        padding: 0 5px;

        &:last-child {
          padding: 0 30px 0 10px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1300px) {
  
  .v-stepper__step {   
    flex: 0 1 80px;
    padding: 0;
    padding-top: 22px;
    align-self: center;
    width: 80px;
    
    ::v-deep .v-stepper__label {
      visibility: hidden;    
      
    }
    ::v-deep .v-stepper__step__step:hover + .v-stepper__label {
      visibility: visible;    
      
    }        
  }  
  .v-divider {
    margin: 35px -20px 0 !important;
  }
}
</style>

